import {Branch} from "@/model/branch";
import {api} from "@/lib/api";

export interface IEmployee {
    employee_id: string;
    branch_id: string;
    wx_union_id: string;
    wx_nick_name?: string;
    name: string;
    phone_number: string;
    wechat_qr_string: string;
}

export class Employee {
    constructor(readonly branch: Branch, readonly meta: IEmployee) {
    }

    async update(name: string, phone_number: string, wqs: string): Promise<void> {
        return api({
            url: `user/${this.branch.brand.meta.agent_id}/brand/${this.branch.meta.brand_id}/branch/${this.meta.branch_id}/employee/${this.meta.employee_id}`,
            method: 'PUT',
            data: Object.assign(this.meta, {name, phone_number, wechat_qr_string: wqs})
        }).then(() => {
            this.meta.name = name
            this.meta.phone_number = phone_number
            this.meta.wechat_qr_string = wqs
        })
    }

}